/**
 * The ONE toast payload for a refused series move — shared by the dialog
 * save path and the grid drag path, which used to carry two hand-copied
 * versions of it (the drift the shared `scopeTouchesSeries` predicate
 * exists to prevent, reintroduced one layer up).
 *
 * Why refusal exists at all: submitting a start the rule contradicts is
 * Microsoft's silent-discard path — 200 OK, nothing moves, and the next
 * pull reverts the move locally too. The server enforces the same contract
 * in-transaction (SERIES_MOVE_UNSUPPORTED); this client copy is the instant
 * feedback.
 */
export function seriesMoveRefusalToast(reason: string): {
  title: string;
  description: string;
  variant: 'destructive';
} {
  return {
    title: 'Cannot move the whole series',
    description: reason,
    variant: 'destructive',
  };
}
